import type { FC, JSX } from 'react';
import { STAR_MEDAL_ICON } from '@/app/common/sustainabilityCertificate.ts';

import { Icon } from '@/app/common/icons/Icon';
import type { CertificationVariant } from './styled.ts';
import { CertificationContainer, CertificationLabel } from './styled.ts';

type CertificationProps = {
  /** From useSustainabilityCertificateLabel — empty when the hotel is uncertified or the toggles are off. */
  label: string;
  isOverlay: boolean;
  variant: CertificationVariant;
};

const Certification: FC<CertificationProps> = ({ label, isOverlay, variant }): JSX.Element | null => {
  if (!label) return null;

  return (
    <CertificationContainer $isOverlay={isOverlay} $variant={variant} data-testid="hotel-certification">
      <Icon {...STAR_MEDAL_ICON} size={20} />
      <CertificationLabel variant="BodySmall" color="textPrimary">
        {label}
      </CertificationLabel>
    </CertificationContainer>
  );
};

export default Certification;
